import { useState } from "react";
import { useI18n } from "../i18n/I18nProvider";
import { marketApi } from "./api";
import { Dialog, useArs } from "./components";

/** "Hacer una oferta": a lower price for some copies of a listing; the shop answers in Mis ofertas. */
export function OfferDialog({ listingId, max, listPrice, onClose }: { listingId: number; max: number; listPrice: number; onClose: () => void }) {
  const { t } = useI18n();
  const ars = useArs();
  const [price, setPrice] = useState("");
  const [qty, setQty] = useState(1);
  const [state, setState] = useState<"idle" | "sending" | "sent">("idle");
  const [error, setError] = useState<string | null>(null);
  const value = Number(price);
  const valid = Number.isInteger(value) && value > 0 && value < listPrice;
  return (
    <Dialog title={t("mkt.offerTitle")} onClose={onClose}>
      {state === "sent" ? (
        <p>{t("mkt.offerSent")}</p>
      ) : (
        <form
          className="stack"
          onSubmit={async (e) => {
            e.preventDefault();
            if (!valid) return;
            setState("sending");
            setError(null);
            try {
              await marketApi.makeOffer(listingId, qty, value);
              setState("sent");
            } catch (err) {
              setState("idle");
              setError(err instanceof Error && "code" in err && (err as { code: string }).code === "offer_open" ? t("mkt.offerOpen") : t("error.generic"));
            }
          }}
        >
          <p className="muted small">{t("mkt.offerIntro", { price: ars(listPrice) })}</p>
          <div className="field">
            <label htmlFor="offer-price">{t("mkt.offerPrice")}</label>
            <input id="offer-price" type="number" min={1} max={listPrice - 1} inputMode="numeric" value={price} onChange={(e) => setPrice(e.target.value)} required />
          </div>
          {max > 1 && (
            <div className="field">
              <label htmlFor="offer-qty">{t("mkt.quantity")}</label>
              <input id="offer-qty" type="number" min={1} max={max} value={qty} onChange={(e) => setQty(Math.max(1, Math.min(max, Number(e.target.value) || 1)))} />
            </div>
          )}
          {error && <p className="form-error">{error}</p>}
          <button type="submit" className="btn btn-primary" disabled={!valid || state === "sending"}>
            {t("mkt.offerSend")}
          </button>
        </form>
      )}
      <button type="button" className="btn btn-link" onClick={onClose}>
        {t("nav.close")}
      </button>
    </Dialog>
  );
}
